<template>
  <a-modal title="编辑办件查询配置" :visible="visible" :maskClosable="false" :width="960" destroyOnClose
    @cancel="$emit('cancel')">
    <template slot="footer">
      <a-button key="submit" :loading="loading" type="primary" @click="submit">确定</a-button>
      <a-button key="back" @click="$emit('cancel')">取消</a-button>
    </template>
    <a-form :form="form" class="custom pick-100 form-input">
      <a-row>
        <a-col :span="10" :offset="1">
          <a-form-item label="访问路径">
            <a-input v-decorator="['webPath', { initialValue: initData.webPath }]" placeholder="请输入访问路径"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="1">
          <a-form-item label="状态">
            <a-radio-group v-decorator="['state', { initialValue: initData.state, rules: [{ required: true, message: '请选择状态' }]}]">
              <a-radio :value="'E'">启用</a-radio>
              <a-radio :value="'D'">禁用</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="21" :offset="1">
          <span>查询权限：</span>
          <a-button @click="onAdd" type="primary">添加权限</a-button>
        </a-col>
        <a-col :span="21" :offset="1" style="margin-top:10px;">
          <a-table ref="table" :columns="columns" :data-source="data" bordered :rowKey="(record, index) => index" :pagination="false">
            <template slot="permKey" slot-scope="record">
             {{ record.extras.permName }}
            </template>
            <template slot="scope" slot-scope="record">
             {{ record.extras.scope }}
            </template>
            <template slot="operation" slot-scope="record">
              <a-button type="primary" @click="onEditPermission(record)">修改</a-button>&nbsp;
              <a-popconfirm placement="bottom" title="是否确认删除?" @confirm="onDeletePermission(record)">
                <a-button :loading="loading">删除</a-button>
              </a-popconfirm>
            </template>
          </a-table>
        </a-col>
      </a-row>
    </a-form>
    <!-- 添加 -->
    <WFCaseQueryPermissionAdd :visible="addVisible" :configId="initData.id" @success="success" @cancel="cancel"/>
    <!-- 编辑 -->
    <WFCaseQueryPermissionEdit ref="permEdit" :visible="editVisible" @success="editSuccess" @cancel="editCancel"/>
  </a-modal>
</template>

<script>
import qs from 'qs'
import WFCaseQueryPermissionAdd from './WFCaseQueryPermissionAdd.vue'
import WFCaseQueryPermissionEdit from './WFCaseQueryPermissionEdit.vue'

export default {
  components: {
    WFCaseQueryPermissionAdd,
    WFCaseQueryPermissionEdit
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this),
      initData: {
      },
      columns: [
        {
          title: '权限',
          scopedSlots: { customRender: 'permKey' }
        },
        {
          title: '查询范围',
          scopedSlots: { customRender: 'scope' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          width: '200px'
        }
      ],
      data: [],
      addVisible: false,
      editVisible: false
    }
  },
  created () {
  },
  methods: {
    // 权限操作 start
    // 编辑
    onEditPermission (record) {
      this.editVisible = true
      this.$refs.permEdit.init(record)
    },
    editSuccess () {
      this.editVisible = false
      this.loadData(this.initData.id)
    },
    editCancel () {
      this.editVisible = false
    },
    // 添加
    onAdd () {
      this.addVisible = true
    },
    cancel () {
      this.addVisible = false
    },
    success () {
      this.addVisible = false
      this.loadData(this.initData.id)
    },
    // 删除
    onDeletePermission (record) {
      let that = this
      this.$http.post('/api/1/workflow/config/delete_permission.json?permKey=' + record.permKey + '&scope=' + record.scope)
        .then(function () {
          that.$message.success('删除成功')
          that.loadData(that.initData.id)
        })
    },
    loadData (configId) {
      const that = this
      this.$http.get('/api/1/workflow/config/get_permission_list.json?configId=' + configId).then(function (response) {
        that.data = response.result
      })
    },
    // 权限编辑 end
    preEdit (configId) {
      const that = this
      this.loadData(configId)
      this.$http.get('/api/1/workflow/config/get_config.json?id=' + configId)
        .then(function (response) {
          that.initData = response.result
        })
    },
    submit () {
      const that = this
      this.loading = true
      this.form.validateFields((err, values) => {
        if (err) {
          this.loading = false
          return
        }
        let data = that.form.getFieldsValue()
        data.id = this.initData.id
        this.$http.post('/api/1/workflow/config/update_config.json', qs.stringify(data, { allowDots: true }))
          .then(function (response) {
            that.$message.success('保存成功')
            that.$emit('success')
            that.loading = false
          })
      })
    }
  }
}
</script>

<style scoped></style>
